import IconAsMaskImage from '../IconAsMaskImage'

function Attachment({ pureSvg, className, color, ...rest }) {
  const svg = (
    <svg {...rest} xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.75 3.75C8.19329 3.75 4.5 7.44329 4.5 12C4.5 16.5558 8.19335 20.25 12.75 20.25C17.3067 20.25 21 16.5558 21 12C21 7.44329 17.3067 3.75 12.75 3.75ZM3 12C3 6.61487 7.36487 2.25 12.75 2.25C18.1351 2.25 22.5 6.61487 22.5 12C22.5 17.3841 18.1352 21.75 12.75 21.75C7.36481 21.75 3 17.3841 3 12Z"
        fill="#FFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.41406 13.6945C9.74247 13.442 10.2133 13.5036 10.4658 13.832C11.0428 14.5828 11.8652 15.0209 12.7511 15.0209C13.1653 15.0209 13.5011 15.3567 13.5011 15.7709C13.5011 16.1852 13.1653 16.5209 12.7511 16.5209C11.3447 16.5209 10.1025 15.8207 9.2765 14.7462C9.02407 14.4178 9.08566 13.9469 9.41406 13.6945Z"
        fill="#851575"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.95696 9.66797C9.784 9.66797 9.6039 9.75218 9.4639 9.93439C9.21152 10.2628 8.74067 10.3245 8.41222 10.0721C8.08377 9.81978 8.02209 9.34892 8.27446 9.02047C8.66376 8.51381 9.26398 8.16797 9.95696 8.16797C10.6499 8.16797 11.2502 8.51381 11.6395 9.02047C11.8918 9.34892 11.8302 9.81978 11.5017 10.0721C11.1733 10.3245 10.7024 10.2628 10.45 9.93439C10.31 9.75218 10.1299 9.66797 9.95696 9.66797Z"
        fill="#851575"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4247 9.66797C15.2518 9.66797 15.0717 9.75218 14.9317 9.93439C14.6793 10.2628 14.2084 10.3245 13.88 10.0721C13.5515 9.81978 13.4899 9.34892 13.7422 9.02047C14.1315 8.51381 14.7318 8.16797 15.4247 8.16797C16.1177 8.16797 16.7179 8.51381 17.1072 9.02047C17.3596 9.34892 17.2979 9.81978 16.9695 10.0721C16.641 10.3245 16.1702 10.2628 15.9178 9.93439C15.7778 9.75218 15.5977 9.66797 15.4247 9.66797Z"
        fill="#851575"
      />
    </svg>
  )

  if (pureSvg) return svg

  return <IconAsMaskImage {...{ svg, className, color }} />
}

export default Attachment
